module.exports = __webpack_public_path__ + "media/images/new/icons/required_docs-126f5a48aa097b33007a8b445aadd08e.png";